import script from "./headerNew.vue?vue&type=script&setup=true&lang=js"
export * from "./headerNew.vue?vue&type=script&setup=true&lang=js"

import "./headerNew.vue?vue&type=style&index=0&id=61de7716&scoped=true&lang=css"

import exportComponent from "F:\\proj-abhinav\\meraki\\patient-portal-v3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61de7716"]])

export default __exports__